export const calculatePerformance = (trade) => {
    const entryPrice = trade.entry_price;
    const exitPrice = trade.exit_price || trade.market_symbol.last_price;

    if (!entryPrice || !exitPrice) {
        return null;
    }

    if (trade.direction.toLowerCase() === 'short') {
        return ((entryPrice - exitPrice) / entryPrice) * 100;
    }

    return ((exitPrice - entryPrice) / entryPrice) * 100;
};

export const formatPerformance = (performance) => {
    if (performance === null || isNaN(performance)) {
        return '-';
    }

    const fixedPerformance = performance.toFixed(2).replace('.', ',');
    const sign = performance > 0 ? '+' : '';

    return `${sign}${fixedPerformance}%`;
};

export const getDirectionBackground = (direction) => {
    const background = {
        Long: 'bg-dashboard-lightGreen text-dashboard-lightGreen',
        Short: 'bg-dashboard-lightRed text-dashboard-lightRed'
    };

    return background[direction] || '';
};
